import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledScrollbar = styled.div`
	--item-size: ${({itemSize}) => itemSize};
	max-height: calc((var(--item-size) * 5));
`;

StyledScrollbar.propTypes = {
	itemSize: PropTypes.string
};

StyledScrollbar.defaultProps = {
	itemSize: '3.6rem'
};

export default StyledScrollbar;
